import GoalInfo from './GoalInfo';

export default GoalInfo;
